export enum USERS_TABLES {
  Users = "Users",
  UsersInvitations = "Users invitations",
}
